<template>
    <modal id="sale-card-import"
           v-model="showModal"
           :title="$fieldTitle('import', 'card', true)"
           :btnLabel="$t('import')"
           :loading="loading"
           :preloader="preloader"
           @submit="submitData">

        <form ref="form" :data-url='`${TENANT_BASE_URL}app/sale-card/import`' @submit.prevent="submitData">
            <app-form-group
                :label="$t('file')"
                type="file"
                v-model="file"
                :required="true"
                :placeholder="$placeholder('file', 'xlsx')"
                :file-label="$placeholder('file', 'xlsx')"
                :error-message="$errorMessage(errors, 'file')"
            />
        </form>
    </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {TENANT_BASE_URL} from "../../../../../common/Config/UrlHelper";
import {formDataAssigner} from "../../../../../common/Helper/Support/FormHelper";

export default {
    name  : "CardImportModal",
    mixins: [FormHelperMixins, ModalMixin],
    data() {
        return {
            TENANT_BASE_URL,
            file: null,
        }
    },
    methods: {
        submitData() {
            this.loading   = true
            const url      = this.$refs.form.dataset["url"];
            const formData = formDataAssigner(new FormData, this.formData);

            formData.set('import_file', this.file)

            this.submitFromFixin('post', url, formData);
        },
        afterSuccess({data}) {
            $('#sale-card-import').modal('hide');
            this.$emit('input', false);
            this.toastAndReload(data.message, 'sale-card-table');
        },
        afterSuccessFromGetEditData(response) {
            this.preloader = false;
            this.file      = null;
        },
    },
}
</script>

